import { ArcElement, Chart, ChartOptions, Legend, Tooltip } from "chart.js";
import React from "react";
import { Pie } from "react-chartjs-2";
import { backgroundColorsPieChart } from "../utils/common";

Chart.register(ArcElement, Tooltip, Legend);

interface Props {
  data: any;
  title: string;
  percentageTrue?: boolean;
}

const ESPieChart: React.FC<Props> = ({ data, title, percentageTrue = false }) => {
  const pieChartData = {
    labels: data?.map((item: any) => item.Title),
   datasets: [
  {
    label: title,
    data: data?.map((item: any) => item.Count),
    backgroundColor: data?.map(
      (item: any, index: number) => backgroundColorsPieChart[index % backgroundColorsPieChart?.length]
    ),
    //  hoverBackgroundColor: data?.map(
    //   (item: any, index: number) => backgroundColorsPieChart[index % backgroundColorsPieChart?.length]
    // ),
    // borderColor: data?.map(
    //   (item: any, index: number) => borderColorsPieChart[index % borderColorsPieChart?.length]
    // ),
    borderWidth: 1,
    hoverOffset: 1,
    maintainAspectRatio: true,
  },
],
  };

  const options: ChartOptions<'pie'> = {
    plugins: {
      legend: {
        display: true,
        position: 'left',
        labels: {
    boxWidth: 15, 
    padding: 15,  
  },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw as number;
            return percentageTrue
              ? `${context.label}: ${value}%`
              : `${context.label}: ${value}`;
          },
        },
      },
    },
    layout: {
      padding: 0, // Remove padding around the chart
    },
    maintainAspectRatio: false, // Allows chart to fully utilize container space
    responsive: true, // Ensure responsiveness
  };


  return(
    <div style={{ 
      height: "37.5vh", 
      width: "100%",
      justifyContent: "center", 
      alignItems: "center" 
    }}>
      <div style={{ 
        height: "100%", 
        width: "100%", 
        maxWidth: "100%"
      }}>
        <Pie data={pieChartData} options={options}/>
      </div>
    </div>
  ) 
};

export default ESPieChart;


 